import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import "./ResourceCards.css";

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 40,
  },
});

export const ResourceCards = () => {
  const classes = useStyles();

  return (
    <div className="card__container">
      <div className="card" id="card__one">
        <Card className={classes.root}>
          <CardActionArea>
            <CardMedia
              className={classes.media}
              image="https://images.squarespace-cdn.com/content/v1/5ccb395cfbe9550001f98602/1571987217466-BHE70E6JX8IPBBUMP1PY/ke17ZwdGBToddI8pDm48kODEHMGUBRgRRplOmqRomK1Zw-zPPgdn4jUwVcJE1ZvWhcwhEtWJXoshNdA9f1qD7Xj1nVWs2aaTtWBneO2WM-vKKmLGZcam4wNLVFkW8ocU3wCuzBZdxfWEqO227KYmPQ/43-SOLID-SAND-250px.jpg?format=300w"
              title=""
            />
            <CardContent className="card__content">
              <Typography gutterBottom variant="h5" component="h2">
                Links To More Information.
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                component="p"
                className="card__links"
              >
                <a
                  className="links"
                  href="https://www.nimh.nih.gov/index.shtml"
                  target="_blank"
                >
                  -NATIONAL INST. OF MENTAL HEALTH
                </a>
                <br />
                <a
                  className="links"
                  href="https://www.mentalhealth.gov/"
                  target="_blank"
                >
                  -MENTALHEALTH.GOV
                </a>
                <br />
                <a
                  className="links"
                  href="http://www.tylerproject.org/"
                  target="_blank"
                >
                  -THE TYLER PROJECT
                </a>
                <br />
                <a
                  className="links"
                  href="https://www.intherooms.com/home/"
                  target="_blank"
                >
                  -IN THE ROOMS
                </a>
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </div>

      <div className="card" id="card__two">
        <Card className={classes.root}>
          <CardActionArea>
            <CardMedia
              className={classes.media}
              image="https://images.squarespace-cdn.com/content/v1/5ccb395cfbe9550001f98602/1571987216468-QAXJZ6PNUO6ULXF46UFC/ke17ZwdGBToddI8pDm48kODEHMGUBRgRRplOmqRomK1Zw-zPPgdn4jUwVcJE1ZvWhcwhEtWJXoshNdA9f1qD7Rb66VC8y5UmDKESC3gpGyXuuE80dFkeX9PanWgM3V4qRJePadRz66WmX0L5eMAEew/19-SOLID-Honeydew-250px.png?format=300w"
              title=""
            />
            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                className="card__title"
              >
                GET HELP
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                <b>National Suicide Prevention Hotline</b>
                <br />
                1-800-273-8255
                <br />
                <b>SAMHSA's National Helpline</b> <br />
                1-800-662-HELP (4357)
                <br />
                <b>Crisis Text Hotline</b>
                <br />
                Text 'START' to
                <br />
                741-741
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </div>

      <div className="card" id="card__three">
        <Card className={classes.root}>
          <CardActionArea>
            <CardMedia
              className={classes.media}
              image="https://images.squarespace-cdn.com/content/v1/5ccb395cfbe9550001f98602/1571987215890-GC1AUT3BIAA0G0KPE17T/ke17ZwdGBToddI8pDm48kODEHMGUBRgRRplOmqRomK1Zw-zPPgdn4jUwVcJE1ZvWhcwhEtWJXoshNdA9f1qD7Rb66VC8y5UmDKESC3gpGyXuuE80dFkeX9PanWgM3V4qRJePadRz66WmX0L5eMAEew/15-SOLID-Shoal-250px.png?format=300w"
              title=""
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Mental Health Doesn't Discriminate
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                <b>All</b> races, genders, sexual orientation, ethnics, income
                levels, etc are impacted by mental health struggles.
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </div>

      <div className="card" id="card__four">
        <Card className={classes.root}>
          <CardActionArea>
            <CardMedia
              className={classes.media}
              image="https://images.squarespace-cdn.com/content/v1/5ccb395cfbe9550001f98602/1571987217063-AAQDEBND2Z8F9BA6Y5A4/ke17ZwdGBToddI8pDm48kODEHMGUBRgRRplOmqRomK1Zw-zPPgdn4jUwVcJE1ZvWhcwhEtWJXoshNdA9f1qD7Xj1nVWs2aaTtWBneO2WM-vKKmLGZcam4wNLVFkW8ocU3wCuzBZdxfWEqO227KYmPQ/30-SOLID-STRAW-250px.jpg?format=300w"
              title=""
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="h2">
                Think It Through
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                What you think effects how you feel and what you do and
                everything you do has either a positive or negative consequence.
                Explore tools to help you understand your emotions.
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button size="small" color="primary">
              <Typography
                variant="body2"
                color="textSecondary"
                component="p"
                className="card__links"
              >
                <a
                  className="links"
                  href="https://www.mind-diagnostics.org/"
                  target="_blank"
                >
                  LEARN MORE
                </a>
              </Typography>
            </Button>
          </CardActions>
        </Card>
      </div>
    </div>
  );
};
